import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IResetAccountIntegrationsRequest {
	accountId: string;
	integrationProvider: Api.IntegrationProvider;
}

export const useResetAccountIntegrationsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (account: Api.IAccount, variables: IResetAccountIntegrationsRequest) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ accountId }: IResetAccountIntegrationsRequest) => {
			return userSession.webServiceHelper.callAsync<Api.IAccount>(
				`admin/account/${accountId}/reset?includeIntegrations=true`,
				'POST'
			);
		},
		onError,
		onSuccess,
	});
};
